import React, { useEffect, useState } from 'react';
import { Modal } from '@abyss/web/ui/Modal';
import { Layout } from '@abyss/web/ui/Layout';
import { Button } from '@abyss/web/ui/Button';
import { useOverlay } from '@abyss/web/hooks/useOverlay';
import { useModalStore, ModalState } from '@src/store/common/ModalStore';

export const ModalComponent = () => {
  const modalOverlay = useOverlay('crdp-modal');

  const initialState: ModalState = {
    title: '',
    message: '',
    handleConfirm: () => {},
    handleCancel: null,
    cancelText: 'Cancel',
    submitText: 'Confirm',
  };
  const [modal, setModal] = useState<ModalState>(initialState);

  const modalState = useModalStore((state) => state.modalState);
  const displayModal = useModalStore((state) => state.displayModal);

  useEffect(() => {
    setModal(modalState);
  }, [modalState]);

  const handleClose = async () => {
    if (modalState.handleCancel !== null) {
      await modalState.handleCancel();
    }
    await displayModal({
      ...initialState, // Spread the initial state properties to reset
    });
    modalOverlay.close();
  };

  const handleSubmit = async () => {
    await modalState.handleConfirm();
    await displayModal({
      ...initialState, // Spread the initial state properties to reset
    });
    modalOverlay.close();
  };

  return (
    <Modal
      model="crdp-modal"
      size="md"
      titleAlign="left"
      onClose={handleClose}
      title={modal.title}
    >
      <Modal.Section>{modal.message}</Modal.Section>
      <Modal.Section>
        <Layout.Group alignLayout="right">
          <Button variant="outline" onClick={handleClose}>
            {modal.cancelText}
          </Button>
          <Button onClick={handleSubmit}>{modal.submitText}</Button>
        </Layout.Group>
      </Modal.Section>
    </Modal>
  );
};
